import React from 'react';

import { TableCell } from '@gogame/components';

import { useFormatValue } from 'scenes/SmartRules/hooks';

import { TableCellFailed } from './styled';

const FAILED = 'Failed';

const ActionMetricsBlock = ({ actionMetricsValues, totalRowSpan }) => {
  const formatValue = useFormatValue();

  return actionMetricsValues.map(
    ({ value, actionValue, actionStatus, metricValueType }, i) => (
      <React.Fragment>
        <TableCell key={'total_' + i} align={'center'} rowSpan={totalRowSpan}>
          {formatValue(value, metricValueType)}
        </TableCell>
        {actionStatus === FAILED ? (
          <TableCellFailed align={'center'} rowSpan={totalRowSpan}>
            failed
          </TableCellFailed>
        ) : (
          <TableCell align={'center'} rowSpan={totalRowSpan}>
            {formatValue(actionValue, metricValueType)}
          </TableCell>
        )}
      </React.Fragment>
    )
  );
};

export default ActionMetricsBlock;
